import { Heading } from '@mm/components';
import { UsersIcon } from '@mm/icons';
import { Contact } from '@mm/state/interfaces/contacts';
import { selectContactsByAudienceId } from '@mm/state/selectors/contactsSelector';
import { getUniqId } from '@mm/utils/src/get-uniq-id';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { useFetchAudienceContacts } from '../../use-fetch-audience-contacts';
import './AudiencePreviewLazy.pcss';

type Props = {
  className?: string;
  audienceId: number;
};

export const AudiencePreviewLazy = ({ className, audienceId }: Props) => {
  const { fetchMore, isFetching } = useFetchAudienceContacts(audienceId, {
    skipBusy: true,
  });

  const contactsByAudienceId = useSelector(state =>
    selectContactsByAudienceId(state, audienceId),
  );
  const { contacts = [], pagination } = contactsByAudienceId || {};

  const count = pagination?.total;
  const noResults = !count;

  const hasMore = !pagination?.isLastPage;

  const onMoreRequest = () => fetchMore(pagination);

  const generateFirstName = (contact: Contact) => {
    if (contact.firstName && contact.username) {
      if (contact.firstName === 'Instagram Contact' && contact.username) {
        return `@${contact.username}`;
      }
      return `${contact.firstName}`;
    }
    if (contact.firstName) {
      return `${contact.firstName}`;
    }
    if (contact.username) {
      return `@${contact.username}`;
    }
  };

  const generateLastName = (contact: Contact) => {
    if (contact.lastName) {
      if (contact.lastName === 'IG') {
        return null;
      }
      return `${contact.lastName}`;
    }
    return null;
  };

  return (
    <div className={classNames(className, 'audience-preview-lazy')}>
      <div className="audience-preview-lazy__topbar">
        <UsersIcon className="audience-preview-lazy__contacts_icon" />
        <Heading size={4} text="Matching contacts" />
        <div className="audience-preview-lazy__contacts-counter">{count}</div>
      </div>
      <div className="audience-preview-lazy__contact audience-preview-lazy__contacts-header">
        <span className="audience-preview-lazy__contact-data">First Name</span>
        <span className="audience-preview-lazy__contact-data">Last Name</span>
      </div>
      <section className="audience-preview-lazy__contacts">
        {noResults && !isFetching && (
          <span className="audience-preview-lazy__empty-state-message">
            No matching contacts
          </span>
        )}
        {!noResults &&
          contacts.map(c => (
            <div className="audience-preview-lazy__contact" key={getUniqId()}>
              <span className="audience-preview-lazy__contact-data">
                {generateFirstName(c)}
              </span>
              <span className="audience-preview-lazy__contact-data">
                {generateLastName(c)}
              </span>
            </div>
          ))}
        {hasMore && !isFetching && (
          <Waypoint bottomOffset="-20px" onEnter={onMoreRequest} />
        )}
        {(noResults || hasMore) && isFetching && (
          <div className="audience-preview-lazy__loading-indicator">
            <span>Loading...</span>
          </div>
        )}
      </section>
    </div>
  );
};
